// extracted by mini-css-extract-plugin
module.exports = {"page":"login_page__3Of-_","email":"login_email__3fS93","code":"login_code__1tQGs"};